var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.payload
    ? _c("div", { staticClass: "block-editor user-input payload" }, [
        _c("div", { staticClass: "user-input-header" }, [
          _c(
            "span",
            {
              directives: [
                {
                  name: "tippy",
                  rawName: "v-tippy",
                  value: { followCursor: true, placement: "top-center" },
                  expression: "{ followCursor: true, placement: 'top-center' }",
                },
              ],
              staticClass: "material-icons",
              attrs: {
                content:
                  "Keywords is a matching system in ChatBot. It works great when you want a unique phrase or a word to trigger a bot response.",
              },
            },
            [_vm._v("\n            help_outline\n        ")]
          ),
          _vm._v("\n        Keywords\n    "),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "keywords" },
          _vm._l(_vm.payload.keywords, function (k, i) {
            return _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.payload.keywords[i],
                  expression: "payload.keywords[i]",
                },
              ],
              key: "keyword-" + i,
              staticClass: "keyword",
              class: { filled: !!_vm.payload.keywords[i].length },
              staticStyle: { "max-width": "fit-content" },
              attrs: {
                maxlength: "50",
                type: "text",
                placeholder:
                  _vm.showPlaceholder !== i
                    ? _vm.$t("chatbotv2.addKeyword")
                    : "",
              },
              domProps: { value: _vm.payload.keywords[i] },
              on: {
                blur: _vm.onBlur,
                focus: function ($event) {
                  _vm.showPlaceholder = i
                },
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.payload.keywords, i, $event.target.value)
                },
              },
            })
          }),
          0
        ),
        _vm._v(" "),
        _c("div", { staticClass: "user-input-header" }, [
          _c(
            "span",
            {
              directives: [
                {
                  name: "tippy",
                  rawName: "v-tippy",
                  value: { followCursor: true, placement: "top-center" },
                  expression: "{ followCursor: true, placement: 'top-center' }",
                },
              ],
              staticClass: "material-icons",
              attrs: {
                content:
                  "User says is a matching system in ChatBot. This system analyzes the full user query to pair it with the chatbot response that matches the best.",
              },
            },
            [_vm._v("\n            help_outline\n        ")]
          ),
          _vm._v(
            "\n        " + _vm._s(_vm.$t("chatbotv2.userSays")) + "\n    "
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "says" },
          _vm._l(_vm.payload.inputs, function (k, i) {
            return _c("TiptapEditor", {
              key: "tiptap-" + i,
              attrs: {
                "show-emoji": true,
                "show-attributes": true,
                placeholder: _vm.$t("chatbotv2.addUserMessage"),
                "max-character-count": 6200,
                "enter-enabled": false,
                "parameter-validation-mode": true,
                "omit-validation": ["regex"],
              },
              model: {
                value: _vm.payload.inputs[i],
                callback: function ($$v) {
                  _vm.$set(_vm.payload.inputs, i, $$v)
                },
                expression: "payload.inputs[i]",
              },
            })
          }),
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "trigger-from-anywhere" },
          [
            _c("md-icon", { staticStyle: { margin: "0" } }, [_vm._v("help")]),
            _vm._v(" "),
            _c("span", [
              _vm._v(
                " " + _vm._s(_vm.$t("chatbotv2.triggerFromAnywhere")) + " "
              ),
            ]),
            _vm._v(" "),
            _c("md-switch", {
              staticStyle: { margin: "0" },
              model: {
                value: _vm.payload.triggerFromAnywhere,
                callback: function ($$v) {
                  _vm.$set(_vm.payload, "triggerFromAnywhere", $$v)
                },
                expression: "payload.triggerFromAnywhere",
              },
            }),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }